import { takeEvery, call, put } from 'redux-saga/effects';
import {
  dataRequest,
  requestFinished,
  insertUpdateItems as insertUpdateObjectCollectionItems
} from '../../../../../../common/reducers/objectCollection/reducer';

import {
  changeServiceArgs,
  sendRequest as sendRequestSetRead
} from '../../../../common/reducers/userNoticesSetReadForm';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import EventsUserNoticeService from '../../../../services/EventsUserNoticeService';

function* setRead(noticeId) {
  const userNoticesSetReadFormRN = 'eventsModule.forms.userNoticesSetReadForm';
  yield put(changeServiceArgs(userNoticesSetReadFormRN, [noticeId]));
  yield put(sendRequestSetRead(userNoticesSetReadFormRN));
}

function* eventsUserNoticesCollectionSaga(reducerName, action) {
  let status = null;
  try {
    const result = yield call(
      timeoutCall,
      EventsUserNoticeService.getNotice,
      action.payload.objectId
    );
    if (result.response) {
      status = result.response.status;
      if (result.response.status) {
        yield put(
          insertUpdateObjectCollectionItems(reducerName, result.destructData)
        );
        if (
          result.destructData[action.payload.objectId].noticeAppStatus === 1
        ) {
          yield setRead(action.payload.objectId);
        }
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, action.payload.objectId, status));
}

export default function createSaga(reducerName) {
  return [
    takeEvery(
      dataRequest(reducerName).type,
      eventsUserNoticesCollectionSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/reducers/static/collections/sagas/eventsUserNoticesCollectionSaga.js